export function setTitle(title: string) {
  try {
    document.title = `${title} | gratico`;
  } catch (e) {
    // ssr
  }
}

export * from "../utils/boot";
